import { render, staticRenderFns } from "./ConfirmDeleteAccountPage.vue?vue&type=template&id=1bc856bc"
import script from "./ConfirmDeleteAccountPage.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteAccountPage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeleteAccountPage.vue?vue&type=style&index=0&id=1bc856bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports